import { LineGraphComponent, Props as LineGraphComponentProps } from './LineGraphComponent';

const LineGraphComponentAngular = ({
  data,
  ratingsFilter,
  chartsScaleFactor,
}: LineGraphComponentProps) => {
  return (
    <LineGraphComponent
      data={data}
      ratingsFilter={ratingsFilter}
      chartsScaleFactor={chartsScaleFactor}
    />
  );
};

export default {
  ReactComponent: LineGraphComponentAngular,
  bindings: {
    data: '<',
    ratingsFilter: '<',
    chartsScaleFactor: '<',
  },
};
